export default "__VITE_ASSET__BTQFMTiO__"